<!--告警统计-->
<template>
    <div class="operation-warn-statistics">
        <content-view>
            <template slot="header">
                <div class="pl16 font-weight font-biggest">
                    告警统计
                </div>
            </template>
            <template v-if="shopMonitorInfo.level || String(shopId) === '-1'">
                <div class="pl32 pr32 pb32 pt32 bg-white operation-warn-statistics-top flex flex-space-between">
                    <div class="operation-warn-statistics-top-left">
                        <div class="operation-warn-statistics-top-left-top flex flex-start">
                            <span class="font-biggest text-color-85">{{ Boolean(shopId) && String(shopId) === '-1' ? '门店实时数据' : shopName}}</span>
                            <span class="text-fail font-big ml8 flex" v-if="Boolean(shopId) && String(shopId) !== '-1'">
                            <img class="mr8" width="16px" height="19px" :src="opMIcon[shopMonitorInfo.level]" alt="">
                            <template v-if="shopMonitorInfo.level !== 'ok'">
                                {{ shopMonitorInfo.effectiveDuration | SEC2DHM }}
                            </template>
                        </span>
                        </div>
                        <div class="text-color-45">
                            <template v-if="Boolean(shopId) && String(shopId) !== '-1'">
                                <template v-if="shopMonitorInfo.level !== 'ok'">
                                    <span>告警时间</span>
                                    <a-divider type="vertical"></a-divider>
                                    <span>{{ shopMonitorInfo.effectiveStart | isEmpty}}</span>
                                </template>
                            </template>
                            <template v-else>
                                <span>{{ $moment().format('YYYY-MM-DD HH:mm:ss') }}</span>
                            </template>
                        </div>
                    </div>
                    <div class="operation-warn-statistics-top-right flex">
                        <template v-if="Boolean(shopId) && String(shopId) === '-1'">
                            <div class="operation-warn-statistics-top-right-statistics-block text-center">
                                <div class="text-color-45">故障门店</div>
                                <div class="text-fail statistics-number">{{ shopWarningInfo.criticalNum }}</div>
                            </div>
                            <a-divider type="vertical" class="ml40 mr40" style="height: 50px;"></a-divider>
                            <div class="operation-warn-statistics-top-right-statistics-block text-center">
                                <div class="text-color-45">预警门店</div>
                                <div class="text-warn statistics-number">{{ shopWarningInfo.warningNum }}</div>
                            </div>
                            <a-divider type="vertical" class="ml40 mr40" style="height: 50px;"></a-divider>
                            <div class="operation-warn-statistics-top-right-statistics-block text-center">
                                <div class="text-color-45">正常门店</div>
                                <div class="text-safe statistics-number">{{ shopWarningInfo.okNum }}</div>
                            </div>
                        </template>
                    </div>
                </div>
                <div v-if="Boolean(shopId) && String(shopId) === '-1'" class="bg-white operation-warn-statistics-middle">
                    <div class="font-big text-color-85 mb16">告警门店</div>
                    <a-table
                        bordered
                        size="middle"
                        :columns="columns"
                        :data-source="dataSource"
                        :pagination="pagination"
                        @change="changePage"
                        :rowKey="row => row.shopId"
                    >
                        <template slot="level" slot-scope="key, row, index">
                            <div class="flex flex-start">
                                <img class="mr8" width="13px" height="15px" :src="opMIcon[key]" alt="">
                                {{key | monitorState}}
                            </div>
                        </template>
                        <template slot="effectiveDuration" slot-scope="key, row, index">
                            {{key | SEC2DHM}}
                        </template>
                        <template slot="isEmpty" slot-scope="key, row, index">
                            {{key | isEmpty}}
                        </template>
                        <template slot="actions" slot-scope="key, row, index">
                            <a class="text-primary" @click="toOperationMonitoring(key, row.shopName)">查看</a>
                        </template>
                    </a-table>
                </div>
                <div class="mt24 bg-white operation-warn-statistics-bottom">
                    <a-card
                        title="门店故障分析"
                        :bordered="false"
                    >
                        <template slot="extra">
                            <a-month-picker :allowClear="false" v-model="date" format="YYYY.MM" @change="monthPickerChange" />
                        </template>
                        <div class="operation-warn-statistics-calendar">
                            <div class="operation-warn-statistics-calendar-days flex">
                                <template v-for="item in days">
                                    <div class="text-center text-color-85" :key="item">{{item}}</div>
                                </template>
                            </div>
                            <div class="operation-warn-statistics-calendar-date mt8 flex">
                                <template v-for="item in currentMonthDateList">
                                    <div class="text-center" :key="item.date">
                                    <span v-if="item.date" :class="`${item.state ? 'state-'+ item.state : ''}`">
                                        {{item.date}}
                                    </span>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="operation-warn-statistics-calendar-legends text-center mt16">
                            <span>异常</span><span class="mark state-c"></span><span class="mark state-b"></span><span class="mark state-a"></span><span>正常</span>
                        </div>
                    </a-card>
                </div>
            </template>
            <template v-else>
                <div class="pb32 pt32 pl32 pr32 bg-white">
                    <div class="text-center operation-empty pt80 pb80">
                        <img width="222" src="../../assets/image/operation-empty.png" alt="">
                        <div class="mt24" style="color: #babcc2; font-size: 24px;">暂无数据</div>
                    </div>
                </div>
            </template>
        </content-view>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import opMIconOk from '../../assets/image/opM-icon-ok.png';
import opMIconWarning from '../../assets/image/opM-icon-warning.png';
import opMIconCritical from '../../assets/image/opM-icon-critical.png';
import opMIconUnknown from '../../assets/image/opM-icon-unknown.png';
export default {
    name: "OperationWarnStatistics",
    components: {
    },
    data() {
        const columns = [
            {
                title: '故障门店',
                dataIndex: 'shopName'
            },
            {
                title: '告警级别',
                dataIndex: 'level',
                scopedSlots: {customRender: 'level'},
            },
            {
                title: '告警时间',
                dataIndex: 'effectiveStart',
                scopedSlots: {customRender: 'isEmpty'},
            },
            {
                title: '持续时长',
                dataIndex: 'effectiveDuration',
                scopedSlots: {customRender: 'effectiveDuration'},
            },
            {
                title: '门店运行',
                dataIndex: 'shopId',
                scopedSlots: { customRender: 'actions'}
            }
        ];
        const days = ['一', '二', '三', '四', '五', '六', '日'];
        return {
            opMIcon: {
                ok: opMIconOk,
                warning: opMIconWarning,
                critical: opMIconCritical,
                unknown: opMIconUnknown
            },
            days,
            currentMonthDateList: [],
            columns,
            dataSource: [],
            shopWarningInfo: {
                criticalNum: 0,
                okNum: 0,
                warningNum: 0
            },
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 5
            },
            shopMonitorInfo: {},
        }
    },
    computed: {
        ...mapGetters(['shopId', 'shopName'])
    },
    watch:{
        shopId() {
            this.monthPickerChange(this.date);
            this.getShopMonitorInfo();
        }
    },
    beforeCreate() {
        this.date = this.$moment();
    },
    mounted() {
        this.monthPickerChange(this.date);
        this.getShopWarningInfoList();
        this.getShopMonitorInfo();
    },
    methods: {
        changePage(pagination) {
            this.pagination = pagination;
        },
        /**
         * @openDetail {callback} 切换监控展示类型。
         */
        toOperationMonitoring(shopId, shopName) {
            this.$router.push({name: 'operationMonitoring', query: { shopId, shopName }});
        },
        /**
         * @monthPickerChange {callback} 月份选择回调。
         */
        monthPickerChange(moment) {
            if (!Boolean(this.shopId)) {
                return false;
            }
            let momentFormat = moment.format('YYYYMM')
            let toDay = this.$moment().set({'hour': 0, 'minute': 0, second: 0});
            this.$api.operationManagement.getShopWarningGrade({
                body: {
                    endDate: this.$moment(moment).endOf('month').format('YYYY-MM-DD'),
                    shopId: this.shopId,
                    startDate: this.$moment(moment).startOf('month').format('YYYY-MM-DD')
                }
            }).then(res => {
                let monthDateList = this.getMonthDateList(moment);
                this.currentMonthDateList = monthDateList.map(i => {
                    if (i) {
                        let currentDayStr = momentFormat + ( i < 10 ? '0' + i : i);
                        let currentDayStrFormat = currentDayStr.substr(0, 4) + '/' + currentDayStr.substr(4, 2) + '/' + currentDayStr.substr(6);
                        let currentDay = this.$moment(currentDayStrFormat + ' 00:00:00');
                        return ({date: i, state: toDay >= currentDay ? res[currentDayStr] : null});
                    } else {
                        return ({date: null});
                    }
                });
            });
        },
        /**
         * @getMonthDateList {method} 获取传入月份对应的日期列表。
         */
        getMonthDateList(moment) {
            let firstDayInMonth = Number(this.$moment(moment).startOf('month').weekday());
            let lastDateInMonth = Number(this.$moment(moment).endOf('month').format("DD"));
            let lastDayInMonth = Number(this.$moment(moment).endOf('month').weekday());
            let monthDateList = [];
            for (let i = 0; i < firstDayInMonth; i++) {
                monthDateList.push(null);
            }
            for (let i = 0; i < lastDateInMonth; i++) {
                monthDateList.push(i + 1);
            }
            for (let i = 0; i < 6 - lastDayInMonth; i++) {
                monthDateList.push(null);
            }
            return monthDateList;
        },
        /**
         * @getShopWarningInfoList {method} 获取告警信息列表。
         */
        getShopWarningInfoList() {
            this.$api.operationManagement.getShopWarningInfoList({}).then(res => {
                this.shopWarningInfo = res;
                this.pagination.total = res.shopWarningInfos.length;
                this.dataSource = this.$utils.deepClone(res.shopWarningInfos);
            });
        },
        /**
         * @getShopMonitorInfo {method} 获取门店监控信息。
         */
        getShopMonitorInfo() {
            if (!Boolean(this.shopId) || String(this.shopId) === '-1') {
                return false;
            }
            this.$api.operationManagement.getShopMonitorInfo({
                params: {
                    shopId: this.shopId
                }
            }).then(res => {
                delete res.moduleMonitorInfos;
                this.shopMonitorInfo = res;
            });
        },
    }
}
</script>

<style lang="scss">
    .operation-warn-statistics {
        .operation-empty {
            background: #fafafa;
            border: 1px solid #e9e9e9;
        }
        .text-warn {
            color: #F3C221;
        }
        .text-safe {
            color: #2FC25B;
        }
        &-top {
            &-left {
                &-top {
                    margin-bottom: 12px;
                }
            }
            &-right {
                &-statistics-block {
                    .statistics-number {
                        font-size: 30px;
                        margin-top: 4px;
                    }
                }
            }
        }
        &-middle {
            border-top: 1px solid rgba(0,0,0,0.09);
            padding: 20px  32px;
        }
        &-bottom {
            .operation-warn-statistics-calendar {
                border: 1px solid #E8E8E8;
                user-select: none;
                &-days {
                    border-bottom: 1px solid #E8E8E8;
                    div {
                        flex: 1;
                        background: #FAFAFA;
                        height: 54px;
                        line-height: 54px;
                        border-left: 1px solid #E8E8E8;
                        &:first-of-type {
                            border-left: none;
                        }
                    }
                }
                &-date {
                    width: 100%;
                    flex-wrap: wrap;
                    border-top: 1px solid #E8E8E8;
                    padding-bottom: 16px;
                    >div {
                        width: 14.2857143%;
                        height: 54px;
                        line-height: 54px;
                        >span {
                            display: inline-block;
                            vertical-align: middle;
                            width: 26px;
                            height: 26px;
                            line-height: 26px;
                            border-radius: 50%;
                            &.state-a {
                                background: rgba(47,194,91,0.80);
                                color: #FFFFFF;
                            }
                            &.state-b {
                                background: rgba(47,194,91,0.20);
                                color: rgba(0,0,0,0.85);
                            }
                            &.state-c {
                                background: rgba(0,0,0,0.03);
                                color: rgba(0,0,0,0.85);
                            }
                        }
                    }
                }
                &-legends {
                    span {
                        font-size: 10px;
                        color: #272E44;
                        margin-left: 10px;
                        &:first-of-type {
                            margin-left: 0;
                        }
                    }
                    .mark {
                        display: inline-block;
                        vertical-align: middle;
                        width: 10px;
                        height: 10px;
                        border-radius: 5px;
                        &.state-a {
                            background: rgba(47,194,91,0.80);
                        }
                        &.state-b {
                            background: rgba(47,194,91,0.20);
                        }
                        &.state-c {
                            background: rgba(0,0,0,0.03);
                        }
                    }
                }
            }
        }
    }
</style>
